import getSymbolFromCurrency from "currency-symbol-map";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import { useRillContext } from "../../rill/RillReact/share/base";
import { getDivisor } from "../../utils/stripe-helpers";
import Modal from "../modal-new";

const PendingPerformInvoiceModal = (_) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();
  const {
    activeUser,
    organizationRoleName,
    pendingPerformInvoices = [],
  } = locals;

  if (activeUser.organizationId && organizationRoleName !== "Owner") {
    return (
      <Modal
        className="pending-invoice"
        title={t("pendingInvoice.actionRequiredTitle")}
      >
        <div className="body max-w-lg">
          <p className="mb-8 p2">
            {t("pendingPerformInvoice.organizationFailedPayment")}
          </p>
        </div>
      </Modal>
    );
  }

  const isOrg = !!activeUser.organizationId;

  return (
    <Modal
      className="pending-invoice"
      title={t("pendingInvoice.paymentFailedTitle")}
    >
      <div className="body max-w-176">
        {pendingPerformInvoices.length > 0 && (
          <>
            <span className="text-(--danger)">
              {t("pendingInvoice.pending")}
            </span>
            <h2 className="mt-1 mb-2">
              {getSymbolFromCurrency(pendingPerformInvoices[0].currency)}
              {pendingPerformInvoices.reduce(
                (total, invoice) => total + invoice.total,
                0
              ) / getDivisor(pendingPerformInvoices[0].currency)}{" "}
              {pendingPerformInvoices[0].currency.toUpperCase()}
            </h2>
            <section role="table-wrapper" data-borders-inside="true">
              <table role="report-table" className="rounded-lg!">
                <thead>
                  <tr>
                    <th>{t("pendingInvoice.invoiceNumber")}</th>
                    <th>{t("pendingInvoice.invoiceDate")}</th>
                    <th>{t("pendingInvoice.amount")}</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {pendingPerformInvoices.map((invoice) => {
                    const {
                      id,
                      number,
                      effective_at,
                      created,
                      currency,
                      total,
                      hosted_invoice_url,
                    } = invoice;
                    const symbol = getSymbolFromCurrency(currency);
                    const divisor = getDivisor(currency);
                    const amount = total / divisor;
                    return (
                      <tr key={id}>
                        <td>{number}</td>
                        <td>
                          {moment((effective_at || created) * 1000).format(
                            "MMM D, YYYY"
                          )}
                        </td>
                        <td>
                          {symbol}
                          {amount} {currency.toUpperCase()}
                        </td>
                        <td>
                          <a
                            href={hosted_invoice_url}
                            data-button-type="primary"
                            role="button"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-0! h-8!"
                          >
                            {t("pendingInvoice.pay")}
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </section>
          </>
        )}
        <p className="mt-4 p2">
          {t(
            isOrg
              ? "pendingPerformInvoice.orgPaymentFailed"
              : "pendingPerformInvoice.yourPaymentFailed"
          )}
        </p>

        <p className="mt-4 p2">
          {t("pendingPerformInvoice.gymManagementSmoothly")}
        </p>

        <p className="mt-4 p2">
          <Trans t={t} i18nKey="pendingInvoice.clickPayAbove">
            Click the <strong>Pay</strong> button above to view your invoice and
            complete the payment.
          </Trans>
        </p>

        <div className="chip info mt-8">
          {t("pendingInvoice.contactUsHint")}
        </div>
      </div>

      <footer>
        <a
          data-button-type="outline"
          role="button"
          href="/coaching-portal/support/contact"
        >
          <span>{t("pendingInvoice.contactUs")}</span>
        </a>
      </footer>
    </Modal>
  );
};

export default PendingPerformInvoiceModal;
